var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('TopHeader',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"text-h5"},[_vm._v(" Manage users ")])]},proxy:true}])}),_c('v-row',[_c('v-col',[_c('manage-users',{attrs:{"fill-height":"","searchable":"","height":_vm.$vuetify.breakpoint.height - 280}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }